<script setup lang="ts"></script>

<template>
  <div
    :class="[
      'grid',
      'md:gap-y-12.5 md:gap-x-32',
      'grid-cols-1 md:grid-cols-[[first-col]_minmax(0px,1fr)_[second-col]_minmax(0px,1fr)_[third-col]_minmax(0px,2fr)_[last-col]]',
      'grid-rows-[repeat(auto, minmax(0, 1fr))] md:grid-rows-[[first-row]_auto_[second-row]_auto_[third-row]]',
      'pt-15 md:px-15 lg:px-25 px-5 pb-10 sm:px-10 md:pb-20 md:pt-20',
    ]"
  >
    <slot />
  </div>
</template>
